import * as React from "react"
import { StyleProp, TextStyle, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Text } from "../text/text"
import { JalaIcon } from "../jala-icon/jala-icon"
import { TouchableOpacity } from "react-native-gesture-handler"
import { SafeAreaView } from "react-native-safe-area-context"
import { View } from "native-base"

const FLOATING_CONTAINER: ViewStyle = {
  position: 'absolute',
  bottom: 12,
  left: 12,
  right: 12,
}

const FLOATING_BUTTON: ViewStyle = {
  flexDirection: 'row',
  borderRadius: 60,
}

const FLOAT_BTN = (position: string): ViewStyle => ({
  flex: position === 'left' ? 0.7 : 1,
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: position === 'left' ? color.palette.blueAzure : color.primary,
  borderTopLeftRadius: position === 'left' ? 60 : 0,
  borderBottomLeftRadius: position === 'left' ? 60 : 0,
  borderTopRightRadius: position === 'right' ? 60 : 0,
  borderBottomRightRadius: position === 'right' ? 60 : 0,
  paddingVertical: 10,
  paddingHorizontal: 20
})

const FLOAT_TEXT: TextStyle = {
  color: color.palette.white,
  marginLeft: 12
}

export interface FloatButtonProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>
  onRightPress?: () => void
  onLeftPress?: () => void
}

/**
 * Describe your component here
 */
export const FloatButton = observer(function FloatButton(props: FloatButtonProps) {
  const { onLeftPress, onRightPress } = props

  return (
    <SafeAreaView style={FLOATING_CONTAINER}>
      <View style={FLOATING_BUTTON} shadow="4" zIndex={6}>
        <View style={FLOAT_BTN('left')}>
          <TouchableOpacity onPress={onLeftPress}>
            <View flexDirection="row">
              <JalaIcon name="sort" size={20} color={color.palette.white} />
              <Text preset="title4" tx="filter" style={FLOAT_TEXT} />
            </View>
          </TouchableOpacity>
        </View>
        <View style={FLOAT_BTN('right')}>
          <TouchableOpacity onPress={onRightPress}>
            <View flexDirection="row">
              <JalaIcon name="add" size={20} color={color.palette.white} />
              <Text preset="title3" tx="addNote" style={FLOAT_TEXT} />
            </View>
          </TouchableOpacity>
        </View>
      </View>
    </SafeAreaView>
  )
})
